import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import { RouterLink } from '@angular/router'

import { IconUi } from '../icons/icon-ui'
import { Clicks } from '@shared/directives'

@Component({
  selector: 'page-header',
  imports: [IconUi, RouterLink, Clicks],
  templateUrl: './page-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex items-center gap-4 w-full'
  }
})
export class PageHeader {
  title = input.required<string>()
  linkBack = input<string | string[]>()

  linkBackText = computed(() => {
    const linkBack = this.linkBack()
    if (!linkBack) return null

    if (Array.isArray(linkBack)) {
      return linkBack.join('/')
    }

    return linkBack
  })
}
